import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import { Buffer } from 'buffer';
import { showApiError } from 'utils';
import { postReq } from './axios';
var renewTokenListener;
var tokenKey = 'token';
var BASE_URL = "".concat(apiUrl, "/auth");

var isTokenValid = function isTokenValid(tokenData, threshold) {
  var decodedToken = decodeToken(tokenData);
  return !!decodedToken && (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.exp) * 1000 - threshold > Date.now();
};

export var getMyUser = function getMyUser() {
  return postReq("".concat(BASE_URL, "/me"));
};
export var loginService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
    var _ref2, _res$message;

    var _yield$postReq, _yield$postReq2, res, err;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return postReq("".concat(BASE_URL, "/login"), body);

          case 2:
            _yield$postReq = _context.sent;
            _yield$postReq2 = _slicedToArray(_yield$postReq, 2);
            res = _yield$postReq2[0];
            err = _yield$postReq2[1];

            if (!err) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", showApiError(err));

          case 8:
            if (res) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", showApiError({
              data: 'Грешка при свързване. Опитайте отново.'
            }));

          case 10:
            if (!(res !== null && res !== void 0 && res.two_factor_required)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", res);

          case 12:
            if (res !== null && res !== void 0 && res.access_token) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", showApiError({
              data: (_ref2 = (_res$message = res === null || res === void 0 ? void 0 : res.message) !== null && _res$message !== void 0 ? _res$message : res === null || res === void 0 ? void 0 : res.error) !== null && _ref2 !== void 0 ? _ref2 : 'Грешка при вход. Опитайте отново.'
            }));

          case 14:
            setToken(res);
            registerRenewTokenListener();
            return _context.abrupt("return", res);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loginService(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var verify2faService = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(body) {
    var _yield$postReq3, _yield$postReq4, res, err;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return postReq("".concat(BASE_URL, "/verify-2fa"), body);

          case 2:
            _yield$postReq3 = _context2.sent;
            _yield$postReq4 = _slicedToArray(_yield$postReq3, 2);
            res = _yield$postReq4[0];
            err = _yield$postReq4[1];

            if (!err) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", showApiError(err));

          case 8:
            if (res !== null && res !== void 0 && res.access_token) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", softLogout());

          case 10:
            setToken(res);
            registerRenewTokenListener();
            return _context2.abrupt("return", res);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function verify2faService(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var getToken = function getToken() {
  try {
    var token = localStorage.getItem(tokenKey);
    return token ? JSON.parse(atob(token)) : null;
  } catch (_unused) {
    softLogout();
    return null;
  }
};
export var softLogout = function softLogout() {
  localStorage.clear();
  unregisterTokenListener();
  window.location = '/';
};
export var renewToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var tokenData, _yield$postReq5, _yield$postReq6, res, err;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            tokenData = getToken();

            if (tokenData) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", softLogout());

          case 3:
            unregisterTokenListener();

            if (!isTokenValid(tokenData, 60000)) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", registerRenewTokenListener());

          case 6:
            _context3.next = 8;
            return postReq("".concat(BASE_URL, "/refresh"));

          case 8:
            _yield$postReq5 = _context3.sent;
            _yield$postReq6 = _slicedToArray(_yield$postReq5, 2);
            res = _yield$postReq6[0];
            err = _yield$postReq6[1];
            if (err) showApiError(err);

            if (res !== null && res !== void 0 && res.access_token) {
              _context3.next = 15;
              break;
            }

            return _context3.abrupt("return", softLogout());

          case 15:
            setToken(res);
            registerRenewTokenListener();

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function renewToken() {
    return _ref4.apply(this, arguments);
  };
}();
export var registerRenewTokenListener = function registerRenewTokenListener() {
  var _decodeToken;

  var tokenData = getToken();
  if (!tokenData) return;
  var expirationTime = ((_decodeToken = decodeToken(tokenData)) === null || _decodeToken === void 0 ? void 0 : _decodeToken.exp) * 1000 - Date.now() - 60000;
  renewTokenListener = setTimeout(function () {
    renewToken();
  }, expirationTime);
};
export var unregisterTokenListener = function unregisterTokenListener() {
  renewTokenListener && clearTimeout(renewTokenListener);
};
export var tokenHeader = function tokenHeader() {
  return getToken() ? "Bearer ".concat(getToken().access_token) : '';
};
export var setToken = function setToken(token) {
  try {
    localStorage.setItem(tokenKey, btoa(JSON.stringify(token)));
  } catch (_unused2) {
    softLogout();
  }
};
export var decodeToken = function decodeToken(tokenData) {
  var _tokenData$access_tok;

  return JSON.parse(Buffer.from(tokenData === null || tokenData === void 0 ? void 0 : (_tokenData$access_tok = tokenData.access_token) === null || _tokenData$access_tok === void 0 ? void 0 : _tokenData$access_tok.split('.')[1], 'base64').toString());
};